<template>
  <container>
    <div class="pg-title-row">
      <div>
        <h1 class="pg-title">Promo Codes</h1>
        <p class="pg-title-sub">Create, search and manage discount codes used by runners</p>
      </div>
    </div>

    <div class="pc-card">
      <div class="pc-header">
        <div class="pc-header-left">
          <span class="pc-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20.59 13.41l-7.18 7.18a2 2 0 0 1-2.82 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
              <line x1="7" y1="7" x2="7.01" y2="7"/>
            </svg>
          </span>
          <div>
            <h2 class="pc-title">Code Library</h2>
            <p class="pc-subtitle">Review usage limits, expiration dates and attached tags</p>
          </div>
        </div>
        <button class="pc-add-btn" @click="showAddPromoCodeModal">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 5v14M5 12h14"/>
          </svg>
          Create Promo Code
        </button>
      </div>

      <div class="pc-toolbar">
        <label class="pc-search-label">
          <svg class="pc-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
          <v-text-field
            placeholder="Search by promo code or tag"
            v-model="searchPromoCode"
            @keyup.enter="handleSearchPromoCode"/>
        </label>
        <button class="pc-search-btn" @click="handleSearchPromoCode">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
          Search
        </button>
      </div>

      <div v-if="loading" class="pc-skeleton-table">
        <div class="pc-skeleton-header">
          <div v-for="n in 5" :key="'pc-sk-head-' + n" class="pc-sk-head sk-shimmer"></div>
        </div>
        <div v-for="row in 7" :key="'pc-sk-row-' + row" class="pc-skeleton-row">
          <div v-for="col in 5" :key="'pc-sk-cell-' + row + '-' + col" class="pc-sk-cell sk-shimmer"></div>
        </div>
      </div>

      <div v-else class="pc-table-wrap">
        <v-table
          is-horizontal-resize
          class="pc-table"
          :columns="columns"
          :table-data="tableData"
          :paging-index="(pageIndex-1)*pageSize"
          @on-custom-comp="customCompFunc">
        </v-table>

        <div v-if="!tableData || tableData.length === 0" class="pc-empty">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#c8c8d8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.59 13.41l-7.18 7.18a2 2 0 0 1-2.82 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
            <line x1="7" y1="7" x2="7.01" y2="7"/>
          </svg>
          <p class="pc-empty-text">No promo codes found.</p>
        </div>
      </div>

      <div class="pc-pagination">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :pageIndex ="pageIndex+1" :total="pageTotal" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
      </div>

      <add-promo-code :show="showAddPromoCode" @saved="onSaved" @closed="onClosed"></add-promo-code>
      <edit-promo-code :promoData="promoData" :show="showEditPromoCode" @saved="onSaved" @closed="onClosed"></edit-promo-code>
    </div>
  </container>
</template>
<script>
let dialogOptions = {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    cancelText: 'No',
    okText: 'Yes',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    clicksCount: 3,
    animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
  }
import Container from "@/components/Container"
import PromoCodeService from "../../../../services/promoCode"
import AddPromoCode from './AddPromoCode'
import EditPromoCode from './EditPromoCode'
import VTextField from '@/components/Forms/VTextField'
import { mapActions, mapGetters } from "vuex"
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
export default {
  name: "promoCodes",
  data() {
    return {
       columns: [
          {field: "id", title:'ID', width: 80, titleAlign: 'center',columnAlign:'center'},
          {field: "code", title:'Promo Code', width: 155, titleAlign: 'center',columnAlign:'center',isResize:true},
          {field: "totalTimesUsed", title:'Total Times Used', width: 120, titleAlign: 'center',columnAlign:'center'},
          {field: "usageLimit", title:'Usage Limit', width: 120, titleAlign: 'center',columnAlign:'center'},
          {field: "endTrialInDays", title:'End Trial In Days', width: 120, titleAlign: 'center',columnAlign:'center'}, 
          
          {field: "expirationDate", title:'Expiration Date', width: 135, titleAlign: 'center',
          columnAlign:'center', componentName:'convert-date'}, 
          {field: "tags", title:'Tags', width: 270, titleAlign: 'center',columnAlign:'center',
          componentName:'tags-list',isResize:true
          }, 
          {field: 'custome-adv',width: 100, title: '', titleAlign: 'center',columnAlign:'center',
            componentName:'edit-del'
          }           
          ],
      tableData:[],
      pageIndex:0,
      pageTotal:null,
      pageSize:20, 
      loading:false,
      showAddPromoCode:false ,
      showEditPromoCode:false,
      promoData:{},
      searchPromoCode:''
    }
  },
  computed: {
  },
  methods: {
     getAllPromoCode(){
      this.loading=true
      PromoCodeService.getAllPromoCodes(this.searchPromoCode,this.pageIndex,this.pageSize).then(response => {   
        //console.log("response---",response)
        this.tableData=response.data.content
        this.pageTotal = response.data.totalElements
        this.loading=false
      }).catch(error => {
        console.log("err--->>",error)
        this.loading=false
      })
    },
    customCompFunc(params){ 
      if(params.columeName == 'delete'){
        this.$dialog.confirm("Are you sure you want to delete '"+ params.rowData.code+"' promocode？", dialogOptions)
          .then((dialog) => {
            PromoCodeService.deletePromoCode(params.rowData.id).then(response => {
            this.$delete(this.tableData,params.index)
            }).catch(error => {
                console.log("err--->",error) 
              }) 
          })
      }else{
        this.showEditPromoCode = true
        this.promoData = params
      }
      
    },
    pageChange(pageIndex){
      this.pageIndex = pageIndex-1
      this.getAllPromoCode()        
    },
    pageSizeChange(pageSize){
      this.pageIndex = 0
      this.pageSize = pageSize
      this.getAllPromoCode()        
    },
    showAddPromoCodeModal(){
      this.showAddPromoCode=true
    },
    onClosed(){
      this.showAddPromoCode=false
      this.showEditPromoCode=false
    },
    onSaved(){
      this.getAllPromoCode()   
      this.showAddPromoCode=false
      this.showEditPromoCode=false
    },
    handleSearchPromoCode(){
      //console.log("in search>>>",this.searchPromoCode)
      this.pageIndex = 0
      this.getAllPromoCode()  
    }
  },
  created() {
    this.getAllPromoCode()  
  },
  watch: {},
  components: {
    Container,
    AddPromoCode,
    EditPromoCode,
    VTextField
  }
}

Vue.component('convert-date',{
  template:` <div>{{newdate}}
              </div>
            `,
  mounted () {
    //this.initdata()
  },
  data: () => ({
    newdate: ''
  }),
  props:{
    rowData:{
        type:Object
    },
    field:{
        type:String
    },
    index:{
        type:Number
    }      
  },
  methods:{
    initdata(){
      var utcDate = this.rowData.expirationDate
      if(utcDate !='' && utcDate!=null && utcDate!=undefined){
        this.newdate= moment(utcDate).format('YYYY-MM-DD')
      }else{
        this.newdate=''
      }
    },           
  },
  created () {
    this.initdata()
  },
  watch: {
      rowData: function (val) {
      this.initdata()
    },
  }
})

Vue.component('edit-del',{
        template:` <div class="edit_del_operation">
                        <button id="editBtn" class="pc-row-action" title="Edit promo code" @click.stop.prevent="edit()">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        </button>
                        <!--<button id="deleteBtn" @click.stop.prevent="deleteRunner()"></button> -->
                         <button id="deleteBtn" class="pc-row-action pc-row-action--delete" title="Delete promo code" @click.stop.prevent="deleteRunner()">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                         </button> 
                    </div>
                   `,
        data: () => ({
          path: ''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          edit(){
            let params = {columeName:"edit",rowData:this.rowData,index:this.index}
            this.$emit('on-custom-comp',params)
          },
          deleteRunner(){
            let params = {columeName:"delete",rowData:this.rowData,index:this.index}
            this.$emit('on-custom-comp',params)
          },
          
        },
        created () {
        },
    })
Vue.component('tags-list',{
  template:` <div>{{tagList}}
              </div>
            `,
  mounted () {
    //this.initdata()
  },
  data: () => ({
    tagList: ''
  }),
  props:{
    rowData:{
        type:Object
    },
    field:{
        type:String
    },
    index:{
        type:Number
    }      
  },
  methods:{
    initdata(){
      if(this.rowData.tags){
        this.tagList = this.rowData.tags.map(a => a.name).toString()  
      }
    },           
  },
  created () {
    this.initdata()
  },
  watch: {
      rowData: function (val) {
      this.initdata()
    },
  }
})


</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap');

.pg-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f5;
  margin-bottom: 1.5rem;
}

.pg-title {
  font-family: 'Inter', sans-serif;
  font-size: 34px;
  font-weight: 900;
  letter-spacing: -0.04em;
  color: #1a1a2e;
  line-height: 1.1;
  margin: 0;
}

.pg-title-sub {
  font-size: 13px;
  color: #8a8a9a;
  font-weight: 400;
  margin: 5px 0 0;
}

.pc-card {
  border: 1px solid #e8e8ed;
  border-radius: 14px;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  background: #fff;
}

.pc-header,
.pc-header-left,
.pc-toolbar,
.edit_del_operation {
  display: flex;
  align-items: center;
}

.pc-header {
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 1.25rem;
}

.pc-header-left {
  gap: 12px;
}

.pc-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.pc-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}

.pc-subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8a8a9a;
}

.pc-add-btn,
.pc-search-btn {
  height: 36px;
  padding: 0 18px;
  border-radius: 8px;
  border: none;
  background: #5b4fcf;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
  transition: background 0.18s ease;
  white-space: nowrap;
}

.pc-add-btn:hover,
.pc-search-btn:hover {
  background: #4338ca;
}

.pc-toolbar {
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #f0f0f5;
  border-radius: 10px;
  background: #fafafa;
  margin-bottom: 1rem;
}

.pc-search-label {
  position: relative;
  flex: 1 1 auto;
  min-width: 220px;
}

.pc-search-icon {
  position: absolute;
  top: 50%;
  left: 13px;
  transform: translateY(-50%);
  color: #8a8a9a;
  z-index: 1;
}

.pc-search-label .text-field {
  width: 100% !important;
  height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #e8e8ed !important;
  background: #fff !important;
  padding: 7px 14px 7px 38px !important;
  font-size: 13px !important;
  color: #1a1a2e !important;
}

.pc-table-wrap {
  overflow-x: auto;
}

.pc-table {
  width: 100%;
  font-size: 12px;
}

.pc-table-wrap .v-table {
  border: 1px solid #f0f0f5;
  border-radius: 10px;
  overflow: hidden;
}

.pc-table-wrap .v-table-header-row,
.pc-table-wrap .v-table-header-cell {
  background: #fafafa;
  color: #1a1a2e;
  font-weight: 700;
}

.pc-table-wrap .v-table-body-row:hover {
  background: #fbfbff;
}

.pc-row-action {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e8e8ed;
  background: #fff;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s ease;
}

.pc-row-action:hover {
  background: #f0effe;
  border-color: #5b4fcf;
}

.pc-row-action--delete {
  color: #c0392b;
}

.pc-row-action--delete:hover {
  background: #fff1f1;
  border-color: #f0b8b8;
}

.edit_del_operation {
  justify-content: center;
  gap: 8px;
}

.pc-pagination {
  padding-top: 1.25rem;
  display: flex;
  justify-content: flex-end;
}

.pc-empty {
  border: 1px dashed #d8d8e6;
  border-radius: 10px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #8a8a9a;
  font-size: 13px;
  margin-top: 12px;
}

.pc-empty-text {
  margin: 0;
}

@keyframes sk-shimmer {
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
}

.sk-shimmer {
  background: linear-gradient(90deg, #f0f0f5 25%, #e4e4ef 50%, #f0f0f5 75%);
  background-size: 600px 100%;
  animation: sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}

.pc-skeleton-table {
  border: 1px solid #f0f0f5;
  border-radius: 10px;
  overflow: hidden;
}

.pc-skeleton-header,
.pc-skeleton-row {
  display: grid;
  grid-template-columns: 0.7fr 1.4fr 1fr 1fr 1.4fr;
  gap: 14px;
  align-items: center;
  padding: 13px 16px;
}

.pc-skeleton-header {
  background: #fafafa;
}

.pc-skeleton-row {
  border-top: 1px solid #f4f4f8;
}

.pc-sk-head,
.pc-sk-cell {
  height: 13px;
}

@media (max-width: 760px) {
  .pc-card {
    padding: 1.2rem;
  }

  .pc-header,
  .pc-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .pc-add-btn,
  .pc-search-btn {
    width: 100%;
  }

  .pc-pagination {
    justify-content: flex-start;
    overflow-x: auto;
  }
}


</style>



// WEBPACK FOOTER //
// PromoCodes.vue?89ec8014